import GetRoutes from './routes/routes';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './shared/components/layout/ThemeProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './lib/queryClient';
import GTMTracker from './components/GTMTracker';
import GTMPageTracker from './components/GTMPageTracker';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ThemeProvider>
        <CssBaseline />
        <GTMPageTracker />
        <GTMTracker pageName="App" />
        <GetRoutes />
      </ThemeProvider>
    </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
